var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('p',[_vm._v("日均短信折线图")]),_c('div',{style:({width: '90%', height: '300px'}),attrs:{"id":"Short"}})])}
var staticRenderFns = []

export { render, staticRenderFns }